import {ErrorMessage, Field} from "formik";
import {DatePickerField} from "./date-picker-field";
import {QuarterPickerField} from "./quarter-picker-field";
import {useRef} from "react";
import BundledEditor from "./articles/bundled-editor";

export default function FormGroup( {
                                     name,
                                     type="text",
                                     label=null,
                                     placeholder=null,
                                     className=null,
                                     style=null,
                                     children=null,
                                     id=null,
                                     options=[],
                                     optionKey='id',
                                     optionLabel='label',
                                     errors=null,
                                     touched=null,
                                     schema=null,
                                     rows=3,
                                     ...props
                                   } ){

  const editorRef = useRef(null);

  return (
    <>
        <div className={`form-group ${className}`} style={style}>
          {label && <label htmlFor={`${id ? id : name}`} className="form-label">{label}</label>}

          {['text', 'password', 'email'].includes(type) && <Field
            type={type}
            name={name}
            id={`${id ? id : name}`}
            placeholder={placeholder}
            className={`form-control ${errors && touched && errors[name] && touched[name] ? "is-invalid":""}`} />}

          {['date', 'datetime'].includes(type) && <DatePickerField
            name={name}
            id={`${id ? id : name}`}
            placeholder={placeholder}
            className={`form-control ${errors && touched && errors[name] && touched[name] ? "is-invalid":""}`}
          />}

          {['quarter'].includes(type) && <QuarterPickerField
            name={name}
            id={`${id ? id : name}`}
            placeholder={placeholder}
            className={`form-control ${errors && touched && errors[name] && touched[name] ? "is-invalid":""}`}
          />}

          {['editor'].includes(type) && <Field
            name={name}
            id={`${id ? id : name}`}
            placeholder={placeholder}
            className={`form-control ${errors && touched && errors[name] && touched[name] ? "is-invalid":""}`}>
            {({ form, field }) => {
              const { setFieldValue, setFieldTouched } = form;

              return (
                <>
                  <BundledEditor
                    tinymceScriptSrc={'/tinymce/tinymce.min.js'}
                    initialValue={field?.value || ''}
                    onInit={(evt, editor) => editorRef.current = editor}
                    init={{
                      language_url: '/other/tinymce-sk.js',
                      language: 'sk',
                      height: 500,
                      menubar: false,
                      plugins: [
                        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
                        'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                        'insertdatetime', 'media', 'table', 'preview', 'wordcount' //, 'help'
                      ],
                      toolbar: 'undo redo | blocks | ' +
                        'bold italic forecolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat', // | help
                      content_style:
                        "body { }"
                    }}
                    onChange={(ed, event) => {
                      const content = event.getContent();
                      if (content) {
                        setFieldTouched(name, true);
                      }
                      setFieldValue(name, content);
                    }}
                  />
                </>
              );
            }}
          </Field>}

          {['checkbox', 'radio'].includes(type) && <div className={'form-check'}>
            <Field
            type={type}
            name={name}
            id={`${id ? id : name}`}
            placeholder={placeholder}
            className={`form-check-input ${errors && touched && errors[name] && touched[name] ? "is-invalid":""}`} />
            <label htmlFor={`${id ? id : name}`} className="form-check-label">{label}</label>
          </div>}

          {['textarea'].includes(type) && <Field
            as="textarea"
            rows={rows}
            name={name}
            id={`${id ? id : name}`}
            placeholder={placeholder}
            className={`form-control ${errors && touched && errors[name] && touched[name] ? "is-invalid":""}`} />}

          {'select'===type && <Field
            as="select"
            name={name}
            id={`${id ? id : name}`}
            placeholder={placeholder}
            className={`form-select ${errors && touched && errors[name] && touched[name] ? "is-invalid":""}`} >
              <option value="">- vyberte možnosť -</option>
              {options && options.length && options.map((opt)=>{
                return <option key={`opt-${opt[optionKey]}`} value={opt[optionKey]}>{opt[optionLabel]}</option>
              })}
          </Field>}

          <ErrorMessage name={name} component="div" className="invalid-feedback" />
          {children}
        </div>
    </>
  );
}
